import {type PIXI} from '@colonist/pixi'
import {type UIGameManager} from '../UIGameManager.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {UIHoverActionController} from './UIHoverActionController.ts'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorSettlement} from '@colonist/game-mechanic-validators'
import {type MechanicSettlementState} from '@colonist/game-states'

export class UISettlementHoverActionController extends UIHoverActionController {
    private readonly settlementValidator: MechanicValidatorSettlement

    constructor(uiGameManager: UIGameManager, settlementState: MechanicSettlementState) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = getCardsForPiece(PieceTypes.Settlement)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildSettlementSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)

        this.settlementValidator = new MechanicValidatorSettlement(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, settlementState)
    }

    getBankActionAmount(index: number): number {
        const settlementPlayerState = this.settlementValidator.getSettlementPlayerState(this.uiGameManager.gameController.myColor)
        return settlementPlayerState.bankSettlementAmount
    }

    protected updateState() {
        const useResources = true
        const canPlaceSettlement = this.settlementValidator.canPlayerPlaceSettlement(this.uiGameManager.gameController.myColor, useResources)
        this.updateHoverLocations(canPlaceSettlement.validHoverLocations, canPlaceSettlement.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getSettlementForPlayer(this.uiGameManager.gameController.myColor)
    }
}
